<ng-container *transloco="let t">
    <div
        class="container"
        fxLayout="row"
        fxLayoutAlign.xs="center"
        fxLayoutAlign.sm="center"
    >
        <div
            fxLayout="row"
            fxLayout.xs="column"
            fxLayout.sm="column"
            fxFlex.xs="90%"
            fxFlex.sm="90%"
            fxLayoutAlign="space-between start"
            fxLayoutAlign.xs="space-between center"
            fxLayoutAlign.sm="space-between center"
        >
            <h1 class="visually-hidden">
                {{ t("application.tab.personal-info") }}
            </h1>
            <div
                fxFlex="612px"
                fxLayoutAlign="center center"
                class="left-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
            >
                <mat-card appearance="outlined">
                    <img
                        src="assets/img/application-icons/personal-info-icon.svg"
                        alt="personal-info-icon"
                    />
                    <h2>{{ t("application.personal-info.header") }}</h2>
                    @if (client$ | async; as client) {
                    <p class="title" [innerHTML]="client.personalInfoHtml"></p>
                    }
                    <p class="subtitle">
                        {{ t("application.personal-info.sub-title") }}
                    </p>
                    <form
                        [formGroup]="personalInformation"
                        (ngSubmit)="onSubmitted()"
                        fxLayout="column"
                    >
                        @if (formSections$ | async; as sections) { @for (section
                        of sections; track section; let i = $index) {
                        <div #sectionWrapper>
                            @if (isSectionVisible(section)) { @if (i > 0) {
                            <mat-divider></mat-divider>
                            } @if ( section.title || section.titleKey ||
                            section.flyoutKey ) {
                            <div class="sub-title">
                                @if ( section.title || section.titleKey ) {
                                <h3>
                                    {{
                                        t(
                                            section.titleKey ??
                                                section.title ??
                                                section.key ??
                                                "",
                                            {
                                                providerName: singleProviderName
                                            }
                                        )
                                    }}
                                </h3>
                                }
                                <app-section-flyout
                                    [flyoutKey]="section.flyoutKey"
                                    [active]="activeFlyoutIndex === i"
                                    [flipUp]="
                                        flyoutFlipUp && activeFlyoutIndex === i
                                    "
                                />
                            </div>
                            } @if ( section.description ||
                            section.descriptionKey ) {
                            <p>
                                {{
                                    t(
                                        section.descriptionKey ??
                                            section.description ??
                                            "",
                                        {
                                            providerName: singleProviderName
                                        }
                                    )
                                }}
                            </p>
                            } @for (row of section.rows; track row) {
                            <div>
                                <app-dynamic-form
                                    [formGroup]="personalInformation"
                                    [fields]="row.fields"
                                    [formSubmitted]="submitted"
                                    [sectionValidators]="
                                        getSectionValidators(section)
                                    "
                                >
                                </app-dynamic-form>
                            </div>
                            } @for ( validator of getSectionErrors( section ) ;
                            track validator.errorKey ?? validator.name) {
                            <mat-error>
                                {{
                                    t(
                                        validator.messageKey ??
                                            validator.message ??
                                            validator.name
                                    ) ??
                                        validator.messageKey ??
                                        validator.message
                                }}
                            </mat-error>
                            } }
                        </div>
                        } }

                        <button
                            mat-stroked-button
                            class="submit"
                            type="submit"
                            [disabled]="submitting"
                        >
                            {{ t("application.save-and-continue") }}
                        </button>
                    </form>
                </mat-card>
            </div>
            <div
                fxFlex="334px"
                fxLayoutAlign="center center"
                class="right-area"
                fxFlex.xs="100"
                fxFlex.sm="100"
                fxHide.xs
                fxHide.sm
            >
                <mat-card appearance="outlined" style="box-shadow: none">
                    <h2>{{ t("application.summary-card.header") }}</h2>
                    <p class="small">
                        {{ t("application.summary-card.title") }}
                    </p>
                    @for (provider of selectedProviders; track provider) {
                    <div>
                        <p class="title">
                            {{ provider.providerName }}
                        </p>
                        <ul>
                            @for (program of provider.programs; track program) {
                            <li>
                                {{ program }}
                            </li>
                            }
                        </ul>
                        <ul>
                            @for (address of provider.addresses; track address)
                            {
                            <li>
                                {{ address }}
                            </li>
                            }
                        </ul>
                    </div>
                    }
                </mat-card>
            </div>
        </div>
    </div>
</ng-container>
